enum ExportTemplateEnum {
    CSV = "csv",
    SAGE50 = "sage_50",
    SAGE100 = "sage_100",
    SIF = "sif",
    FROMM = "fromm",
    BOERLIND = "boerlind",
}

export default ExportTemplateEnum;
